import { useState } from "react";
import { useLocale, useT } from "../../i18n";
import { activeFilterCount } from "../../hooks/useInventory";
import { AdvancedFilters } from "./AdvancedFilters";
import { SortSelect } from "./SortSelect";

// Mobile: one "Filters" button opening the full-screen advanced filter sheet.
export const FilterSheet = ({ filters, setFilters, update, facets, total }) => {
  const t = useT();
  const lang = useLocale();
  const [open, setOpen] = useState(false);
  const count = activeFilterCount(filters);
  return (
    <div className="lg:hidden" data-testid="filter-bar-mobile">
      <div className="flex items-center gap-3">
        <button type="button" onClick={() => setOpen(true)} data-testid="filter-sheet-open"
          className="inline-flex h-11 shrink-0 items-center gap-2 border border-ink bg-ink px-4 text-[12px] font-medium uppercase tracking-[0.14em] text-white">
          {t("filters.filters")}
          {count > 0 && <span className="tabular-nums text-white/60">({count})</span>}
        </button>
        <div className="min-w-0 flex-1">
          <SortSelect value={filters.sort} scope={filters.scope} onChange={(s) => update({ sort: s })} id="mobile-sort" />
        </div>
      </div>
      <AdvancedFilters open={open} onOpenChange={setOpen} filters={filters} setFilters={setFilters} facets={facets} />
      <p className="micro-label mt-4 tabular-nums text-ink/60" data-testid="inventory-count-mobile">
        {lang === "ja" ? `${total ?? "—"}${t("inventory.vehicles")}` : `${total ?? "—"} ${t("inventory.vehicles")}`}
      </p>
    </div>
  );
};
